module.exports = __webpack_public_path__ + "svg_80x80/gcp.07cfdc.svg";